import React from "react";
import { Box, Typography } from "@mui/material";

const Title = ({
  children,
  variant = "body1",
  size = "1.8rem",
  sx = {},
  underline = 1,
  ls = "normal",
}) => {
  return (
    <Box
      sx={{
        display: "inline-block",
        borderBottom: underline ? "1px solid #808080" : "none",
        paddingBottom: underline ? 0 : undefined,
      }}
    >
      <Typography
        variant={variant}
        sx={{
          mb: 0,
          // fontFamily: 'Balgin',
          fontFamily: "'KokuGothic', sans-serif",
          fontSize: size,
          letterSpacing: ls,
          ...sx,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default Title;
